import React, {useState} from 'react';
import './Register.css';
import {Button} from '@material-ui/core';
import db from './firebase';

function Register({switchAcc, click}) {
    var day = [];
    for(let i = 1; i <= 31; i++){
        if(i.toString().length < 2) {
            day.push('0'+i)
        } else {
            day.push(i)
        }
    }
    var month = [];
    for (let x = 1; x <= 12; x++){
        if(x.toString().length < 2) {
            month.push('0'+x)
        } else {
            month.push(x)
        }
    }
    var year = [];
    var tyear = new Date().getFullYear()
    for (let y = 1900; y <= tyear; y++) {
        year.push(y)
    }
    const [disablebox, setDisablebox] = useState(false)
    const selectBox = () => {
        setDisablebox(true) 
    }
    const [disablebox2, setDisablebox2] = useState(false)
    const selectBox2 = () => {
        setDisablebox2(true) 
    }
    const [disablebox3, setDisablebox3] = useState(false)
    const selectBox3 = () => {
        setDisablebox3(true) 
    }
    const [fname, setFname] = useState('')
    const [lname, setLname] = useState('')
    const [email, setEmail] = useState('')
    const [inputDay, setInputDay] = useState('')
    const [inputMonth, setInputMonth] = useState('');
    const [inputYear, setInputYear] = useState('');
    const [password, setPassword] = useState('');

    const createAccount = (event) => {
        event.preventDefault()
        db.collection('users').add({
            firstName: fname,
            lastName: lname,
            email: email,
            birthday: {day:inputDay, month:inputMonth, year:inputYear},
            password: password,
            profileImage: "",
            coverImage : ""
        })
        click()
        localStorage.setItem('usermail', email)
    }
    return (
        <div className="login register">
            <img src="image/logo.png" />
            <h3>Memory</h3>
            <form>
            <div className="name__input">
                <input placeholder="First Name"
                type="text" 
                value={fname}
                onChange={event => setFname(event.target.value)}
                />
                <input placeholder="Last Name" className="last__name"
                type="text"
                value={lname}
                onChange={event => setLname(event.target.value)}
                />
            </div>
            <input placeholder="Email" className="email__input"
            type="email"
            value={email}
            onChange={event => setEmail(event.target.value)}
            />
            <p>Birthday</p>
            <div className="select__options">
                <select 
                className="opt__one" 
                onClick={selectBox}
                value={inputDay} 
                onChange={event => setInputDay(event.target.value)}>
                    <option disabled={disablebox}>Day</option>
                    {
                        day.map(days => (
                            <option value={days}>{days}</option>
                        ))
                    }
                </select>
                <select className="opt__two"
                onClick={selectBox2}
                value={inputMonth} 
                onChange={event => setInputMonth(event.target.value)}
                >
                    <option disabled={disablebox2}>
                        Month
                    </option>
                    {
                        month.map(months => (
                            <option value={months}>{months}</option>
                        ))
                    }
                </select>
                <select className="opt__three"
                onClick={selectBox3}
                value={inputYear} 
                onChange={event => setInputYear(event.target.value)}
                >
                    <option disabled={disablebox3}>
                        Year
                    </option>
                    {
                        year.map(years => (
                            <option value={years}>{years}</option>
                        ))
                    }
                </select>
            </div>
            <input placeholder="Password" type="password"
            value={password}
            onChange={event => setPassword(event.target.value)}
            />
            <Button type="submit" disabled={!fname || !lname || !email &&
            !inputDay || !inputMonth || !inputYear || !password}
            onClick={createAccount}
            >Create Account</Button>
            </form>
            <p onClick={switchAcc}>Login Here?</p>
        </div>
    )
}

export default Register
